import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-no-items',
    templateUrl: '../svgs/NoItems.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--no-items'
    },
    standalone: false
})
export class TellerOnlineIconNoItems {
}
